module.exports = __webpack_public_path__ + "1afc31cb40d2a835af785c11b8241ca9.glb";